/**
 * DevExtreme (esm/__internal/ui/check_box/check_box_icon.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size"];
import { createVNode } from "inferno";
import "../../../ui/themes";
import { normalizeStyleProp } from "../../../core/utils/style";
import { BaseInfernoComponent, normalizeStyles } from "../../core/r1/runtime/inferno/index";
import { createRef as infernoCreateRef } from "inferno";
export const defaultCheckBoxIconProps = {};
export let CheckBoxIcon = /*#__PURE__*/(() => {
  class CheckBoxIcon extends BaseInfernoComponent {
    constructor(props) {
      super(props);
      this.state = {};
      this.elementRef = infernoCreateRef();
      this.__getterCache = {};
    }
    get cssStyles() {
      if (void 0 !== this.__getterCache.cssStyles) {
        return this.__getterCache.cssStyles;
      }
      return this.__getterCache.cssStyles = (() => {
        const {
          size: size
        } = this.props;
        const fontSize = normalizeStyleProp("fontSize", size);
        return {
          fontSize: fontSize
        };
      })();
    }
    get restAttributes() {
      const _this$props = this.props,
        restProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
      return restProps;
    }
    componentWillUpdate(nextProps) {
      if (this.props.size !== nextProps.size) {
        this.__getterCache.cssStyles = void 0;
      }
    }
    render() {
      const {
        elementRef: elementRef,
        cssStyles: cssStyles
      } = this;
      return createVNode(1, "span", "dx-checkbox-icon", null, 1, {
        style: normalizeStyles(cssStyles)
      }, null, elementRef);
    }
  }
  CheckBoxIcon.defaultProps = defaultCheckBoxIconProps;
  return CheckBoxIcon;
})();